import { Injectable } from '@angular/core';
import { OrderDragModel } from '../models/order-drag-and-drop.model';
import { normalizeOrderDates } from '../models/order.model';
import { DragObjectTypeEnum } from '../enums/drag-object-type.enum';
import { BehaviorSubject } from 'rxjs';


const DRAG_ROUTE_PREFIX_ID = "route-id";
const DRAG_REGION_PREFIX_ID = "region-id";

@Injectable()
export class PlannerDraggingManagerService {
    isDragInProgress$ = new BehaviorSubject<boolean>(false);


    isDragRegionValid($event: DragEvent, dataObjectType: DragObjectTypeEnum, vehicleRegionId: number): boolean {
        const dragRegionId = this.getDragRegionId($event, dataObjectType);

        return dragRegionId ? dragRegionId === vehicleRegionId
            : false;
    }

    getDragInfo($event: any, dataObjectId: string): OrderDragModel | null {
        const dragInfoJson = $event.dataTransfer.getData(dataObjectId);

        if (dragInfoJson) {
            const dragInfo = JSON.parse(dragInfoJson);
            const dargInfoNormalized = { ...dragInfo, order: normalizeOrderDates(dragInfo.order) } as OrderDragModel;
            return dargInfoNormalized;
        }

        return null;
    }

    isDraggingShipment($event: DragEvent) {
        return $event.dataTransfer
            ? $event.dataTransfer.types.indexOf(DragObjectTypeEnum.SHIPMENT) >= 0
            : false;
    }

    setDragInfoData($event: DragEvent, dragModel: OrderDragModel, routeId: number | undefined, dataObjectType: string) {
        if ($event.dataTransfer) {
            $event.dataTransfer.setData(dataObjectType, JSON.stringify(dragModel));
            if (dragModel.order.RegionId) {
                $event.dataTransfer.setData(`${dataObjectType}/${DRAG_REGION_PREFIX_ID}/${dragModel.order.RegionId}`, dragModel.order.RegionId.toString());
            }
            if (routeId) {
                $event.dataTransfer.setData(`${dataObjectType}/${DRAG_ROUTE_PREFIX_ID}/${routeId}`, routeId.toString());
            }
        }
    }

    getDragRouteId($event: DragEvent, objectDataType: DragObjectTypeEnum): Number | null {
        let routeId: number | null = null;

        if ($event.dataTransfer) {
            const routeString = $event.dataTransfer.types.find((r: any) => r.startsWith(`${objectDataType}/${DRAG_ROUTE_PREFIX_ID}`))
            if (routeString) {
                const match = routeString.match(/(\d+)$/);

                if (match) {
                    routeId = parseInt(match[1], 10);
                }
            }
        }
        return routeId;
    }

    getDragRegionId($event: DragEvent, objectDataType: DragObjectTypeEnum): Number | null {
        let routeId: number | null = null;

        if ($event.dataTransfer) {
            const routeString = $event.dataTransfer.types.find((r: any) => r.startsWith(`${objectDataType}/${DRAG_REGION_PREFIX_ID}`))
            if (routeString) {
                const match = routeString.match(/(\d+)$/);

                if (match) {
                    routeId = parseInt(match[1], 10);
                }
            }
        }
        return routeId;
    }

    isShipmentDraging($event: DragEvent) {
        return $event.dataTransfer && $event.dataTransfer.types.indexOf(DragObjectTypeEnum.SHIPMENT) >= 0;
    }

    isOrderDraging($event: DragEvent) {
        return $event.dataTransfer && $event.dataTransfer.types.indexOf(DragObjectTypeEnum.ORDER) >= 0;
    }
}